<div class="container-fluid">
  <div class="row">
    <div style="margin-top: 1%; margin-bottom: -50px; margin-left: 10px">
      <h6>
        <span style="padding-right: 5px"></span>
        <!-- <i class="fa fa-globe"></i>
        <b>Route </b>-->
      </h6>
    </div>
  </div>
  <hr />
  <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
    <div class="col-md-12 p-0">
      <div class="form-group">
        <div *ngIf="tranportAssociation" class="row">
          <div class="col-sm-4">
            <label>Transport Association</label>
            <input
              formControlName="transport_assoc"
              [value]="tranportAssociation.description"
              title="Transport Association"
              class="form-control form-control-sm"
              type="text"
              readonly
            />
          </div>
          <br />
        </div>
        <br />

        <div
          *ngIf="
            (btnRadio == '1' ||
              btnRadio == '2' ||
              btnRadio == '3' ||
              isCheck) &&
            (this.mapselectedRoute?.route_type_ind === 1 ||
              this.mapselectedRoute?.route_type_ind === 11) &&
            routeDetials != 'details'
          "
          class="row"
        >
          <div class="col-sm-4">
            <label>Route Name</label>
            <!-- <input formControlName="description" title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)" class="form-control form-control-sm" type="text" readonly/>
          -->

            <select
              formControlName="route_name"
              [disabled]="isDupApplication"
              title="Select a route"
              [(ngModel)]="selectedRoute"
              class="form-control form-control-sm"
              (change)="checked()"
            >
              <option disabled>Select route</option>
              <!-- <option *ngIf="defaultValue  != ''" disabled [value]="defaultValue">{{defaultValue}}</option> -->
              <ng-container>
                <option
                  *ngFor="let r of ownRoutes"
                  [ngValue]="r"
                  selected="r.id == selectedRoute.id"
                >
                  {{ r.description }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>

        <div
          *ngIf="
            (btnRadio == '1' ||
              btnRadio == '2' ||
              btnRadio == '3' ||
              isCheck) &&
            (this.mapselectedRoute?.route_type_ind === 1 ||
              this.mapselectedRoute?.route_type_ind === 11) &&
            routeDetials == 'details'
          "
          class="row"
        >
          <div class="col-sm-4">
            <label>Route Name</label>
            <!-- <input formControlName="description" title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)" class="form-control form-control-sm" type="text" readonly/>
        -->

            <select
              formControlName="route_name"
              [disabled]="isDupApplication"
              title="Select a route"
              [(ngModel)]="selectedRoute"
              class="form-control form-control-sm"
              (change)="checked()"
              class="disabled"
            >
              <option disabled>Select route</option>
              <!-- <option *ngIf="defaultValue  != ''" disabled [value]="defaultValue">{{defaultValue}}</option> -->
              <ng-container>
                <option
                  *ngFor="let r of ownRoutes"
                  [ngValue]="r"
                  selected="r.id == selectedRoute.id"
                >
                  {{ r.description }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>

        <br />

        <div
          class="col-sm-12 p-0 mt-2"
          *ngIf="
            (btnRadio == '1' ||
              btnRadio == '2' ||
              btnRadio == '3' ||
              isCheck) &&
            (this.mapselectedRoute?.route_type_ind === 1 ||
              this.mapselectedRoute?.route_type_ind === 11) &&
            routeDetials != 'details'
          "
        >
          <!-- <ckeditor title="" [readonly]="isDupApplication" formControlName="route_detail"  (input)="changes()" debounce="500">
        </ckeditor> -->
          <quill-editor
            [styles]="{ height: '400px' }"
            formControlName="route_detail"
            [modules]="quillConfig"
            (onEditorCreated)="changes()"
          >
          </quill-editor>
          <button
            *ngIf="!isDupApplication"
            title="Update Route Details"
            name="saveroutedetails"
            type="submit"
            id="btnSave"
            (click)="updateRouteForApproval()"
            class="btn btn-md m-clr pull-right hd-btn"
            style="width: auto; margin-right: 0px; margin-bottom: 5px"
          >
            Update Route Details
          </button>
        </div>

        <div
          class="col-sm-12 p-0 mt-2"
          *ngIf="
            (btnRadio == '1' ||
              btnRadio == '2' ||
              btnRadio == '3' ||
              isCheck) &&
            (this.mapselectedRoute?.route_type_ind === 1 ||
              this.mapselectedRoute?.route_type_ind === 11) &&
            routeDetials == 'details'
          "
        >
          <!-- <ckeditor title="" [readonly]="isDupApplication" formControlName="route_detail"  (input)="changes()" debounce="500">
      </ckeditor> -->
          <quill-editor
            [styles]="{ height: '400px' }"
            formControlName="route_detail"
            [modules]="quillConfig"
            (onEditorCreated)="changes()"
            readOnly="true"
          >
          </quill-editor>
        </div>

        <div
          class="col-sm-12 p-0 mt-2"
          *ngIf="
            mapselectedRoute !== undefined &&
            mapselectedRoute !== null &&
            this.mapselectedRoute?.route_type_ind !== 1 &&
            this.mapselectedRoute?.route_type_ind !== 11
          "
        >
          <div class="col-md-12">
            <table class="table table-sm table-borderless" style="width: 100%">
              <thead>
                <tr>
                  <th
                    class="th-sm"
                    style="text-align: left"
                    style="max-width: 120px !important"
                  >
                    Route Name
                  </th>
                  <th class="th-sm" style="max-width: 120px !important">
                    Description
                  </th>
                  <th class="th-sm">Cargo</th>
                  <th>Route Type</th>
                  <th class="bfr-end-col">Stops</th>
                  <th class="bfr-end-col">Est. distance</th>
                  <th class="btn-show hgt-btn bfr-end-col end-col">
                    Est. duration
                  </th>
                  <th style="min-width: 200px !important"></th>

                  <th>Select Route</th>
                </tr>
              </thead>
              <tr style="height: 200px" class="selected-route">
                <td class="bfr-end-col" style="max-width: 120px !important">
                  {{ mapselectedRoute.description }}
                </td>
                <td class="bfr-end-col" style="max-width: 120px !important">
                  {{ mapselectedRoute.route_summary }}
                </td>
                <td class="bfr-end-col">
                  {{ mapselectedRoute.freight_passenger_ind }}
                </td>
                <td class="bfr-end-col" style="max-width: 100px !important">
                  {{ mapselectedRoute.route_type_ind }}
                </td>
                <td class="bfr-end-col">
                  {{
                    mapselectedRoute.num_border_crossings
                      ? mapselectedRoute.num_border_crossings
                      : 0
                  }}
                </td>
                <td class="bfr-end-col" style="max-width: 120px !important">
                  {{
                    mapselectedRoute.distance ? mapselectedRoute.distance : 0
                  }}
                  km
                </td>
                <td class="bfr-end-col" style="max-width: 120px !important">
                  {{ toHoursAndMinutes(mapselectedRoute.duration) }}
                </td>
                <td>
                  <!-- TO DO, PASS THE SOURCE AND DESTINATION TO THE MAP-->
                  <app-route-viewer-map
                    mapid="map-selected-route"
                    style="width: 200px !important; height: 200px; !important;"
                    [source]="mapselectedRoute.source"
                    [destination]="mapselectedRoute.destination"
                  ></app-route-viewer-map>
                </td>
                <td class="btn-show bfr-end-col">
                  <!--                        <a (click) =selectRoute(cType)><img-->
                  <!--                                src="../../../assets/newimg/border-color-13@2x.png" title="Select Route"-->
                  <!--                                style="cursor: pointer;margin: 10px;"/></a>-->

                  <a (click)="selectRoute(mapselectedRoute)"
                    ><img
                      src="../../../assets/newimg/border-color-52@2x.png"
                      title="Select Route"
                      style="cursor: pointer; margin: 10px"
                  /></a>
                  <!--                        <img src="../../../../../assets/newimg/delete-30@2x.png" title="Delete Route"-->
                  <!--                             (click)="onConfirm(cType.id)" style="cursor: pointer;"/>-->
                </td>
              </tr>
              <tfoot></tfoot>
            </table>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </form>
</div>

<ngx-loading [show]="pageload"></ngx-loading>
